import styled from 'styled-components'
import { media } from '../../../../../styles/_variables'


export const WidthContainer = styled.div`
  margin-top: 48px;
  width: 50%;
  min-width: 300px;
  ${media.desktop`
    width: 50%;
  `}
  ${media.laptopL`
    width: 50%;
  `}
  ${media.laptop`
    width: 60%;
  `}
`
export const FullWidthContainer = styled.div`
  margin-top: 32px;
  width: 100%;
`

export default WidthContainer
